import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Table,
  Button,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
  Alert,
} from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ThreeDotSpinner } from "../loader";
import Pagination from "react-js-pagination";
import swal from "sweetalert";
import { apiService } from "../../service/api.service";
import moment from "moment";
import { apiUrl, dateFormate } from "../../config/config";



export const BannedUsers = () => {
  const [bannedUsers, setBannedUsers] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [showUnbanModal, setShowUnbanModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [unbanReason, setUnbanReason] = useState("");
  const [reasonError, setReasonError] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    getBannedUsers(page, search);
  }, [page, search]);

  const getBannedUsers = async (pageNum, searchTerm) => {
    setLoader(true);
    try {
      const response = await apiService.getBannedUsers(pageNum, searchTerm);
      if (response?.status === 200) {
        setBannedUsers(response.data.data.list || []);
        setTotalItems(response?.data?.data.totalRecords || 0);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        swal({ icon: "error", text: "Unauthorized", button: "OK" }).then(() => {
          localStorage.clear();
          window.location.href = "/";
        });
      } else {
        swal({
          icon: "error",
          text: error?.response?.data?.message || error?.message,
          button: "OK",
        });
      }
    } finally {
      setLoader(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (page !== pageNumber - 1) {
      setPage(pageNumber - 1);
      getBannedUsers(pageNumber - 1, search);
    }
  };

  const handleSearch = (searchTerm) => {
    setSearch(searchTerm);
    setPage(0);
    getBannedUsers(0, searchTerm);
  };

  const handleUnbanClick = (user) => {
    setSelectedUser(user);
    setShowUnbanModal(true);
    setUnbanReason("");
    setReasonError("");
  };

  const handleUnbanConfirm = () => {
    if (unbanReason.trim() === "") {
      setReasonError("Please enter a reason for unbanning");
      return;
    }
    setReasonError("");
    unbanUser(selectedUser.id, unbanReason);
  };

  const unbanUser = async (userId, reason) => {
    setLoader(true);
    try {
      const response = await apiService.unbanUser(userId, reason);
      if (response?.status === 200) {
        swal("Success", "User has been unbanned successfully", "success").then(() => {
          setShowUnbanModal(false);
          setSelectedUser(null);
          setUnbanReason("");
          getBannedUsers(page, search);
        });
      }
    } catch (error) {
      swal({
        icon: "error",
        text: error?.response?.data?.message || error?.message,
        button: "OK",
      });
    } finally {
      setLoader(false);
    }
  };

  const handleCloseUnbanModal = () => {
    setShowUnbanModal(false);
    setSelectedUser(null);
    setUnbanReason("");
    setReasonError("");
  };

  const copyToClipboard = (text) => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div className="dashboard-main-area">
       {loader == true ? <ThreeDotSpinner /> : ""}
      <Container fluid>
          <div className="dashboard-area-heading management-heading">
       <Row className="row justify-content-center align-items-center mb-3">
                    <Col md={12} lg={11}>
              <div className="dashboard-main-content">
                <div className="dashboard-main-content-header">
                  <h2>Banned Users</h2>
                  <p>Manage banned users and unban them if necessary</p>
                </div>

                <div className="dashboard-main-content-body">
                  <Row className="mb-3">
                    <Col lg={6}>
                      <Form.Control
                        type="text"
                        placeholder="Search by wallet address, email, or phone..."
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                        className="search-input"
                      />
                    </Col>
                    <Col lg={6} className="text-end">
                      <Button
                        variant="primary"
                        onClick={() => getBannedUsers(page, search)}
                        className="refresh-btn"
                      >
                        Refresh
                      </Button>
                    </Col>
                  </Row>

                  {bannedUsers.length === 0 && !loader ? (
                    <Alert variant="info" className="text-center">
                      No banned users found
                    </Alert>
                  ) : (
                    <div className="table-responsive">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Wallet Address</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Ban Reason</th>
                            <th>Banned Date</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bannedUsers.map((user, index) => (
                            <tr key={user.id}>
                              <td>{page * limit + index + 1}</td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <span className="wallet-address">
                                    {user.wallet_address
                                      ? `${user.wallet_address.slice(0, 6)}...${user.wallet_address.slice(-4)}`
                                      : "N/A"}
                                  </span>
                                  {user.wallet_address && (
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={<Tooltip>Copy to clipboard</Tooltip>}
                                    >
                                      <CopyToClipboard
                                        text={user.wallet_address}
                                        onCopy={() => copyToClipboard(user.wallet_address)}
                                      >
                                        <Button
                                          variant="link"
                                          size="sm"
                                          className="copy-btn"
                                        >
                                          <i className="fas fa-copy"></i>
                                        </Button>
                                      </CopyToClipboard>
                                    </OverlayTrigger>
                                  )}
                                </div>
                              </td>
                              <td>{user.email || "N/A"}</td>
                              <td>{user.phone || "N/A"}</td>
                              <td>
                                <span className="ban-reason">
                                  {user.ban_reason || "No reason provided"}
                                </span>
                              </td>
                              <td>
                                {user.banned_at
                                  ? moment(user.banned_at).format(dateFormate)
                                  : "N/A"}
                              </td>
                              <td>
                                <Button
                                  variant="success"
                                  size="sm"
                                  onClick={() => handleUnbanClick(user)}
                                  className="unban-btn"
                                >
                                  <i className="fas fa-unlock"></i> Unban
                                </Button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}

                  {totalItems > limit && (
                    <div className="pagination-wrapper">
                      <Pagination
                        activePage={page + 1}
                        itemsCountPerPage={limit}
                        totalItemsCount={totalItems}
                        pageRangeDisplayed={5}
                        onChange={handlePageChange}
                        itemClass="page-item"
                        linkClass="page-link"
                      />
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>
          </div>
        </Container>
      </div>

      {/* Unban Confirmation Modal */}
      <Modal show={showUnbanModal} onHide={handleCloseUnbanModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Unban User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>User Details:</Form.Label>
              <div className="user-details">
                <p><strong>Wallet:</strong> {selectedUser?.wallet_address || "N/A"}</p>
                <p><strong>Email:</strong> {selectedUser?.email || "N/A"}</p>
                <p><strong>Phone:</strong> {selectedUser?.phone || "N/A"}</p>
                <p><strong>Ban Reason:</strong> {selectedUser?.ban_reason || "No reason provided"}</p>
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Reason for Unbanning *</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={unbanReason}
                onChange={(e) => setUnbanReason(e.target.value)}
                placeholder="Enter reason for unbanning this user..."
                isInvalid={reasonError}
              />
              <Form.Control.Feedback type="invalid">
                {reasonError}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUnbanModal}>
            Cancel
          </Button>
          <Button variant="success" onClick={handleUnbanConfirm}>
            Confirm Unban
          </Button>
        </Modal.Footer>
      </Modal>

      {copied && (
        <div className="copy-notification">
          <Alert variant="success" className="copy-alert">
            Copied to clipboard!
          </Alert>
        </div>
      )}
    </>
  );
};
